import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Portal } from 'react-portal';
import ModalComponent from 'components/Common/Modal';
import getAppSite from 'utils/getAppSite';

const ContentPopup = (props) => {
  const { code, contactsPage } = props;
  const location = useLocation();
  const MogulTrial = code.includes('Mogul');

  return (
    <>
      <div className='section-title px-4 py-4'>
        <h3 className='export-message-title text-main-blue mb-0'>
          <span>Export</span>
        </h3>
      </div>
      <div className='px-4 py-3'>
        {contactsPage ? (
          <>
            <p className='text-main-blue'>Exporting contacts is not available during the trial period.</p>
            <p className='mb-0 text-main-blue'>Please upgrade to a paid subscription to use this feature.</p>
          </>
        ) : (
          <>
            {MogulTrial && (
              <>
                <p className='text-main-blue'>
                  Exporting stakeholders is available to paying subscribers on the Mogul or Enterprise plans.{' '}
                </p>
                <p className='mb-0 text-main-blue'>
                  To export your results, please upgrade to a paid Mogul or Enterprise subscription.
                </p>
              </>
            )}
            {!MogulTrial && (
              <p className='mb-4 text-main-blue'>
                Exporting stakeholders is not available whilst you're on a free trial. Please upgrade your subscription
                or contact your account manager.
              </p>
            )}
          </>
        )}
      </div>
      {MogulTrial && getAppSite() !== 'usa' && (
        <Link
          to={`/pricing?returnUrl=${encodeURIComponent(location.pathname)}`}
          className='py-3 d-block text-center border-top'
        >
          <button className='px-3 py-2 action-button general-button'>Compare plans</button>
        </Link>
      )}
    </>
  );
};

const ExportMessage = (props) => {
  const { showPopUp, setShowPopup } = props;
  return (
    <Portal>
      <ModalComponent isOpen={showPopUp} setIsOpen={setShowPopup} maxWidth={331}>
        <ContentPopup {...props} />
      </ModalComponent>
    </Portal>
  );
};

export default ExportMessage;
